// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file onboarding/transfer_item.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.TransferItemRequest
 */
export class TransferItemRequest extends Message<TransferItemRequest> {
  /**
   * @generated from field: string source_non_medical_master_id = 1;
   */
  sourceNonMedicalMasterId = "";

  /**
   * @generated from field: string target_medical_master_id = 2;
   */
  targetMedicalMasterId = "";

  /**
   * @generated from field: string barcode = 3;
   */
  barcode = "";

  constructor(data?: PartialMessage<TransferItemRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferItemRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source_non_medical_master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_medical_master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferItemRequest {
    return new TransferItemRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferItemRequest {
    return new TransferItemRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferItemRequest {
    return new TransferItemRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TransferItemRequest | PlainMessage<TransferItemRequest> | undefined, b: TransferItemRequest | PlainMessage<TransferItemRequest> | undefined): boolean {
    return proto3.util.equals(TransferItemRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TransferItemResponse
 */
export class TransferItemResponse extends Message<TransferItemResponse> {
  constructor(data?: PartialMessage<TransferItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferItemResponse {
    return new TransferItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferItemResponse {
    return new TransferItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferItemResponse {
    return new TransferItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TransferItemResponse | PlainMessage<TransferItemResponse> | undefined, b: TransferItemResponse | PlainMessage<TransferItemResponse> | undefined): boolean {
    return proto3.util.equals(TransferItemResponse, a, b);
  }
}

